<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
    };
  },
  components: {
    conditionPart,
  },
  computed: {
    columns() {
      if (this.reportType == "detail") {
        return [
          {
            name: "TerminalNumber",
          },
          {
            name: "TerminalName",
          },
          {
            name: "BusinessDay",
          },
          {
            name: "SalNumber",
          },
          {
            name: "PayName",
          },
          {
            name: "Number",
          },
          {
            name: "Qty",
          },
          {
            name: "Total",
          },
          {
            name: "OverCharge",
          },
        ];
      } else {
        return [
          {
            name: "TerminalNumber",
          },
          {
            name: "TerminalName",
          },
          {
            name: "BusinessDay",
          },
          {
            name: "PayName",
          },
          {
            name: "Number",
          },
          {
            name: "Qty",
          },
          {
            name: "Total",
          },
          {
            name: "OverCharge",
          },
        ];
      }
    },
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getSalePay(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSalePay(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSalePay(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getSalePay(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
